import { Toaster as Sonner } from "sonner";

/** Feedback toasts, dressed in the villa palette instead of Sonner's default. */
export function Toaster() {
  return (
    <Sonner
      position="bottom-center"
      toastOptions={{
        classNames: {
          toast:
            "rounded-[var(--radius-panel)] border border-ink/14 bg-bg text-ink shadow-[0_18px_50px_rgb(34_38_30_/_0.14)] font-sans",
          title: "font-semibold text-[0.9375rem]",
          description: "text-ink-soft text-sm",
          actionButton: "bg-accent text-on-dark",
          error: "border-danger/40",
          success: "border-accent/40",
        },
      }}
    />
  );
}
